export default {
    cannot_edit_past_reservations: 'Ne možete uređivati rezervacije iz prošlosti.',
    minimum_time_difference_to_edit: 'Ne možete uređivati rezervacije zakazane u narednih sat vremena.',
    invalid_availability_offer: 'Usluga nema dostupne termine.',
    unavailable_for_rescheduling: 'Ne možete mijenjati termin za ovu uslugu.',
    not_permissioned: 'Niste ovlašteni da uredjujete ovu uslugu.',
    not_found: 'Usluga nije pronadjena.',
    time_must_be_in_the_past: 'Vrijeme rezervacije mora da bude u prošlosti.',
    mins_ahead_60: 'Ova rezervacija ne može biti promijenjena. Moguće je izvršiti izmjene najmanje 60 minuta unaprijed.',
    mins_ahead_20: 'Ova rezervacija ne može biti promijenjena. Moguće je izvršiti izmjene najmanje 20 minuta unaprijed.',
    time_zone_issue: 'Molimo vas provjerite vrijeme na Vašem uredjaju. Vrijeme nije kompatibilno sa serverom',
    minimum_5: 'Nije moguće izabrati opciju manju od 5 minuta',
    overlap_too_large: 'Broj izabranih minuta je prevelik. Molimo vas da odaberete manji broj minuta.',
    unavailable_for_allowing_overlap: 'Nije moguće završiti ranije ovu rezervaciju.',
}
